<div class="sidebar-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<span class="card-title-label" translate>home.quality-issues.issues</span>
		<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
			<input [placeholder]="'search.placeholder' | translate" matInput type="text" spellcheck="false" autocomplete="off"
				[formControl]="searchTextControl"/>
			<button type="button" class="mat-button-close" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');" tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
		<button type="button" class="filter-button" (click)="goToFilter()">
			<span class="filter-button-name" translate>datacenter.filters</span>
			<mat-icon class="filter-button-icon" svgIcon="filters"></mat-icon>
		</button>
	</div>
	<div class="copo-container" *ngIf="notPushedQualityIssues && notPushedQualityIssues.length > 0">
		<div class="issue-block issue-block-normal">
			<div *ngFor="let issue of notPushedQualityIssues" class="issue-block-item">
				<div class="issue-block-identity">
					<div class="issue-block-title">
						{{getIssueType(issue) | translate}}
					</div>
					<div class="issue-block-info-item">
						<div class="issue-block-label" translate>claim.placeholder.reference.number</div>
						<div class="issue-block-value">{{ issue.reference ? issue.reference :
							UNDERSCORE }}</div>
					</div>
					<div class="issue-block-info-item">
						<div class="issue-block-label" translate>issue.batch.number</div>
						<div class="issue-block-value">{{getBatchNumbers(issue)}}</div>
					</div>
					<div class="pill issue-block-status" [class.issue-status-bg-error]="isPendingNotPush(issue)">
						<span class="issue-block-status-error-label" translate>quapp.error</span>
					</div>
				</div>
				<div class="issue-block-info">
					<div class="issue-block-info-item">
						<div class="issue-block-label" translate>order.creation.date</div>
						<div class="issue-block-value">{{ issue.creationDate | copoDate:'date' }}</div>
					</div>
					<div class="issue-block-info-item">
						<div class="issue-block-label issue-warning" translate>claim.last.modification</div>
						<div class="issue-block-value issue-warning">{{ issue.modifDate | copoDate:'date' }}
						</div>
					</div>
					<div class="issue-block-info-item">
						<div class="issue-label-amount" translate>claim.requested.amount</div>
						<div class="issue-block-value-large">
							{{ issue.amountValue | copoNumber:'amount':getUnitAmount(issue.amountUnitTr) }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>	
	<div class="copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
		(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<!-- primary layout which is displayed by issue-block-normal style on big resolutions -->
		<div class="issue-block issue-block-normal">
			<div *ngFor="let issue of scroller.list" class="issue-block-item">
				<div class="issue-block-identity">
					<div class="issue-block-title">
						{{getIssueTypeTr(issue) | translate}}
					</div>
					<div class="issue-block-info-item">
						<div class="issue-block-label" translate>claim.placeholder.reference.number</div>
						<div class="issue-block-value">{{ issue.customerReference ? issue.customerReference :
							UNDERSCORE }}</div>
					</div>
					<div class="issue-block-info-item">
						<div class="issue-block-label" translate>issue.batch.number</div>
						<div class="issue-block-value">{{getBatchNumberList(issue)}}</div>
					</div>
					<div class="issue-block-info-item">
						<div class="issue-block-label" translate>issue.supplierissuenumber</div>
						<div class="issue-block-value">{{issue.supplierIssueNumber ? issue.supplierIssueNumber :
							UNDERSCORE }}</div>
					</div>
					<div class="pill issue-block-status" [class.issue-status-bg-pending]="isPending(issue)"
						[class.issue-status-bg-paid]="isPaid(issue)" [class.issue-status-bg-refused]="isRefused(issue)"
						[class.issue-status-bg-other]="isOther(issue)">
						<span class="issue-block-status-label">{{ getIssueStatusTr(issue) | translate }}</span>
					</div>
				</div>
				<div class="issue-block-info">
					<div class="issue-block-info-item">
						<div class="issue-block-label" translate>order.creation.date</div>
						<div class="issue-block-value">{{ issue.creationDate | copoDate:'date' }}</div>
					</div>
					<div class="issue-block-info-item">
						<div class="issue-block-label issue-warning" translate>claim.last.modification</div>
						<div class="issue-block-value issue-warning">{{ issue.modificationDate | copoDate:'date' }}
						</div>
					</div>
					<div class="issue-block-info-item">
						<ng-container *ngIf="issue.amountRequested">
							<div class="issue-label-amount" translate>claim.requested.amount</div>
							<div class="issue-block-value-large">
								{{ issue.amountRequested | copoNumber:'amount':getUnitAmount(issue.currencyRequested) }}
							</div>
						</ng-container>
					</div>
					<div class="issue-block-info-item">
						<ng-container *ngIf="issue.amountAccepted && isPaid(issue)">
							<div class="issue-label-amount" translate>claim.paid.amount</div>
							<div class="issue-block-value-large">
								{{ issue.amountAccepted | copoNumber:'amount':getUnitAmount(issue.currencyAccepted) }}
							</div>
						</ng-container>
					</div>
					<div class="link-credit">
						<ng-container *ngIf="issue.creditNoteDate && isPaid(issue)">
							<a mat-button [routerLink]="['/quality-issues/card/', issue.id]" fragment="documents">
								<span translate>issue.creditnote</span>
								<mat-icon iconPositionEnd svgIcon="table_document"></mat-icon>
							</a>
						</ng-container>
					</div>
					<a mat-button class="issue-block-details" [routerLink]="['/quality-issues/card/', issue.id]">
						<span translate>quality.feedback.card.details</span>
						<mat-icon iconPositionEnd svgIcon="md:chevron_right" color="accent"></mat-icon>
					</a>
				</div>
			</div>
		</div>
		<!-- additional layout which is displayed by issue-block-small style on smaller resolutions -->
		<div class="issue-block issue-block-small">
			<div *ngFor="let issue of scroller.list" class="issue-block-item">
				<div class="issue-block-identity">
					<div class="issue-block-title">
						{{getIssueTypeTr(issue) | translate}}
					</div>
					<div class="pill issue-block-status" [class.issue-status-bg-pending]="isPending(issue)"
						[class.issue-status-bg-paid]="isPaid(issue)" [class.issue-status-bg-refused]="isRefused(issue)"
						[class.issue-status-bg-other]="isOther(issue)">
						<span class="issue-block-status-label">{{ getIssueStatusTr(issue) | translate }}</span>
					</div>
				</div>
				<div class="issue-block-info">
					<div class="issue-col-full">
						<div class="issue-block-info-item issue-block-info-item-separated">
							<div class="issue-block-label" translate>claim.placeholder.reference.number</div>
							<div class="issue-block-value">{{ issue.customerReference ? issue.customerReference :
								UNDERSCORE }}</div>
						</div>
					</div>
					<div class="issue-col-half">
						<div class="issue-block-info-item issue-block-info-item-separated">
							<div class="issue-block-label" translate>issue.batch.number</div>
							<div class="issue-block-value">{{getBatchNumberList(issue, true)}}</div>
						</div>
						<div class="issue-block-info-item issue-block-info-item-separated">
							<div class="issue-block-label" translate>issue.supplierissuenumber</div>
							<div class="issue-block-value">{{issue.supplierIssueNumber ? issue.supplierIssueNumber :
								UNDERSCORE }}</div>
						</div>
						<div class="issue-block-info-item issue-block-info-item-separated"
							*ngIf="issue.amountRequested">
							<div class="issue-label-amount" translate>claim.requested.amount</div>
							<div class="issue-block-value-large">
								{{ issue.amountRequested | copoNumber:'amount':getUnitAmount(issue.currencyRequested) }}
							</div>
						</div>
						<div class="issue-block-info-item">
							<div class="issue-block-label issue-warning" translate>claim.last.modification</div>
							<div class="issue-block-value issue-warning">{{ issue.modificationDate | copoDate:'date'
								}}</div>
						</div>
					</div>
					<div class="issue-col-half">
						<div class="issue-block-info-item issue-block-info-item-separated">
							<div class="issue-block-label" translate>order.creation.date</div>
							<div class="issue-block-value">{{ issue.creationDate | copoDate:'date' }}</div>
						</div>
						<div class="issue-block-info-item issue-block-info-item-separated"
							*ngIf="issue.amountAccepted && isPaid(issue)">
							<div class="issue-label-amount" translate>claim.paid.amount</div>
							<div class="issue-block-value-large">
								{{ issue.amountAccepted | copoNumber:'amount':getUnitAmount(issue.currencyAccepted) }}
							</div>
						</div>
						<div class="link-credit">
							<ng-container *ngIf="issue.creditNoteDate && isPaid(issue)">
								<a mat-button [routerLink]="['/quality-issues/card/', issue.id]" fragment="documents">
									<span translate>issue.creditnote</span>
									<mat-icon iconPositionEnd svgIcon="table_document"></mat-icon>
								</a>
							</ng-container>
						</div>
					</div>
				</div>
				<a mat-button class="issue-block-details" [routerLink]="['/quality-issues/card/', issue.id]">
					<span translate>quality.feedback.card.details</span>
					<mat-icon iconPositionEnd svgIcon="md:chevron_right" color="accent"></mat-icon>
				</a>
			</div>
		</div>
	</div>
	<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
</div>
